import nammaai1 from '../assets/images/nammaai1.png';
import d1 from '../assets/images/d1.jpeg';
import d3 from '../assets/images/d3.jpeg';
import aegiTech from '../assets/images/s5.jpg';
import monieTrack from '../assets/images/s6.png';

interface Project {
  id: number;
  title: string;
  description: string;
  tags: string[];
  image: string;
  details: {
    overview: string;
    features: string[];
    technologies: string[];
    challenges: string;
    results: string;
    demoUrl?: string;
    githubUrl?: string;
  };
}

const projectsData: Project[] = [
  {
    id: 1,
    title: "TRABUC – Travel Booking Application",
    description: "A comprehensive travel booking platform with real-time booking, secure payments, and personalized recommendations.",
    tags: ["React Native", ".NET Web API", "SQL Server", "AWS", "Grafana"],
    image: d1,
    details: {
      overview: "TRABUC is a full-stack travel booking solution that enables users to book flights, hotels, and activities in one platform.",
      features: [
        "Real-time booking system with instant confirmation",
        "Secure payment gateway with multiple payment options",
        "Personalized recommendations based on user preferences",
        "Multi-language support for global users"
      ],
      technologies: [
        "Frontend: React Native with TypeScript",
        "Backend: .NET Web API with C#",
        "Database: SQL Server with Entity Framework",
        "Cloud: AWS EC2 and S3",
        "Monitoring: Grafana dashboards"
      ],
      challenges: "Implemented complex booking logic that handles concurrent reservations and maintains data consistency.",
      results: "Reduced booking time by 40% and increased conversion rate by 25%.",
      demoUrl: "https://trabuc-demo.example.com",
      githubUrl: "https://github.com/yourusername/trabuc"
    }
  },
  {
    id: 2,
    title: "THECLEANGOV – Sanitation Management",
    description: "Government sanitation monitoring platform for urban cleanliness and waste management.",
    tags: ["React Native", ".NET Web API", "SQL Server", "Azure Kubernetes Service","Docker","Grafana"],
    image: d3,
    details: {
      overview: "A government-facing platform that streamlines sanitation operations and citizen reporting for cleaner cities.",
      features: [
        "Real-time GPS tracking of sanitation vehicles",
        "Citizen reporting portal with photo uploads",
        "Analytics dashboard for performance monitoring",
        "Automated route optimization for waste collection"
      ],
      technologies: [
        "Frontend: React Native with TypeScript",
        "Backend: .NET Web API with C#",
        "Database: SQL Server with Entity Framework",
        "Cloud: Azure Kubernetes Service",
        "Containerization: Docker"
      ],
      challenges: "Built a scalable system to handle thousands of concurrent reports during peak hours.",
      results: "Improved sanitation response times by 60% and increased citizen satisfaction scores.",
      demoUrl: "https://thecleangov-demo.example.com"
    }
  },
  {
    id: 3,
    title: "NammaAI - AI Assistant",
    description: "AI-powered assistant leveraging GrokAI's open API for natural language processing.",
    tags: ["Python", "GrokAI API", "React", "WebSockets"],
    image: nammaai1,
    details: {
      overview: "A conversational AI assistant that helps users with daily tasks, information retrieval, and personal organization.",
      features: [
        "Natural language understanding with context awareness",
        "Multi-modal responses (text, voice, images)",
        "Personalization through learning user preferences",
        "Integration with calendar and productivity tools"
      ],
      technologies: [
        "AI: GrokAI API with custom fine-tuning",
        "Backend: Python with FastAPI",
        "Frontend: React with Tailwind CSS",
        "Real-time: WebSockets for live interactions"
      ],
      challenges: "Overcame latency issues in voice responses by implementing streaming audio.",
      results: "Achieved 90% accuracy in intent recognition and reduced response time to under 1 second.",
      githubUrl: "https://github.com/yourusername/nammaai"
    }
  },
  {
    id: 4,
    title: "AEGI-Tech - IT Solutions Website",
    description: "Corporate website for AEGI-Tech showcasing services, portfolio, and client engagement.",
    tags: ["React.js with Typescript", "AWS Amplify", "Tailwind CSS", "Responsive Design"],
    image: aegiTech,
    details: {
      overview: "A modern, responsive corporate website designed to showcase AEGI-Tech's IT services and solutions to potential clients.",
      features: [
        "Interactive service showcase with animated demos",
        "Client portfolio gallery with case studies",
        "Contact form with automated email responses",
        "SEO optimized pages with performance monitoring"
      ],
      technologies: [
        "Frontend: React.js",
        "Styling: Tailwind CSS with custom animations",
        "Deployment: AWS Amplify with CI/CD",
        "Analytics: Google Tag Manager integration"
      ],
      challenges: "Implementing smooth animations without performance hits on mobile devices.",
      results: "Increased client inquiries by 35% and improved SEO ranking to first page for key terms.",
      demoUrl: "https://www.aegi-tech.example.com",
      githubUrl: "https://github.com/yourusername/aegi-tech"
    }
  },
  {
    id: 5,
    title: "MonieTrack - Expense Tracker",
    description: "Personal finance application for tracking expenses, budgets, and financial goals.",
    tags: ["React.js", "Firebase", "Chart.js", "PWA"],
    image: monieTrack,
    details: {
      overview: "A progressive web app that helps users manage their personal finances with intuitive visualizations and budgeting tools.",
      features: [
        "Expense categorization with custom tags",
        "Interactive budget visualization with Chart.js",
        "Multi-currency support with real-time rates",
        "Offline capability (PWA) with data sync",
        "PDF/CSV export for financial reporting"
      ],
      technologies: [
        "Frontend: React.js with Create React App",
        "Backend: Firebase (Authentication, Firestore)",
        "Data Visualization: Chart.js with custom plugins",
        "PWA: Workbox for offline caching"
      ],
      challenges: "Implementing real-time sync across devices while maintaining offline capability and data consistency.",
      results: "Helped users reduce unnecessary spending by an average of 20% through budget awareness.",
      demoUrl: "https://monietrack.example.com",
      githubUrl: "https://github.com/yourusername/monietrack"
    }
  }
];

export const projects = projectsData;